import React, { useContext, useRef, useEffect } from 'react'; // Added useEffect
import './PackageBannerMobileComponent.css';
import { Context } from '../../AppContext';
import { isMobile } from '../../utils/commonUtils';
// import { logRttEventLogger } from '../../logRttRequestBuilder';

const PackageBannerMobileComponent = ({ packageData, pageUrl }) => {
  const { trackTemplateEvent, omniUrlArgs } = useContext(Context);
  const { mweb_banner } = packageData;
  const usps = mweb_banner.usps || [];
  const mobileContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      // If the page was restored from bfcache, the loader might still be active
      if (event.persisted && mobileContainerRef.current) {
        mobileContainerRef.current.classList.remove(
          'mobile-container-loading-active'
        );
      }
    };

    window.addEventListener('pageshow', handlePageShow);

    // Cleanup
    return () => {
      window.removeEventListener('pageshow', handlePageShow);
      // Also, ensure loader is removed if component unmounts for other reasons while loading
      // This is a fallback, pageshow is more direct for bfcache
      if (
        mobileContainerRef.current &&
        mobileContainerRef.current.classList.contains(
          'mobile-container-loading-active'
        )
      ) {
        mobileContainerRef.current.classList.remove(
          'mobile-container-loading-active'
        );
      }
    };
  }, []); // Empty dependency array means this runs once on mount and cleans up on unmount

  const handleMobileBannerClick = () => {
    // Prevent re-triggering if already attempting to load/redirect
    if (
      mobileContainerRef.current &&
      mobileContainerRef.current.classList.contains(
        'mobile-container-loading-active'
      )
    ) {
      return;
    }

    // 1. Activate the loader
    if (mobileContainerRef.current) {
      mobileContainerRef.current.classList.add(
        'mobile-container-loading-active'
      );
    }

    // 2. Initiate redirection
    if (mweb_banner.mweb_redirection_url) {
      // logRttEventLogger({omniUrlArgs, eventName: 'Cab_SEO_Packages_Mobile_Banner_Clicked',pageUrl });
      window.location.href = `${mweb_banner.mweb_redirection_url}&${omniUrlArgs}`;
      trackTemplateEvent(`Cab_SEO_Packages_Mobile_Banner_Clicked`);
    } else {
      // Fallback: If there's no URL, remove the loader after a short delay
      if (mobileContainerRef.current) {
        console.warn(
          'No redirection URL found for mobile banner. Removing loader.'
        );
        setTimeout(() => {
          if (mobileContainerRef.current) {
            mobileContainerRef.current.classList.remove(
              'mobile-container-loading-active'
            );
          }
        }, 7000); // Remove after 0.5s if no redirect
      }
    }
  };

  return isMobile() ? (
    <div
      ref={mobileContainerRef}
      className="packageDataContainerMobile"
      onClick={handleMobileBannerClick} // Make the whole container clickable
    >
      <div className="mobile-banner-content-wrapper">
        {' '}
        {/* Wrapper for content to fade */}
        <div className="makeFlex packageDataSection">
          <div className="makeBlock packageDataSectionInfo">
            <div className="packageDataTitle">{mweb_banner.title}</div>
            <div className="packageDataSubtitle">
              {mweb_banner.city_sub_title}
            </div>
          </div>
          <div className="packageDataViewCabsButton">
            <div className="packageDataCTA">View</div>
            <div className="packageDataArrow">{`>`}</div>
          </div>
        </div>
        <div className="makeFlex packageDataUsp">
          <div className="makeFlex packageDataUspItemList">
            {usps.map((usp, index) => (
              <React.Fragment key={index}>
                <div className="packageDataUspItem">{usp}</div>
                {index < usps.length - 1 && (
                  <div className="packageDataBullet"></div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
      <div className="mobile-container-loader-element"></div>{' '}
      {/* Loader element */}
    </div>
  ) : null;
};

export default PackageBannerMobileComponent;
